module.exports = __webpack_public_path__ + "img/icn-air-force.29e8c62b.png";